export const SEARCH_TYPE = {
  QUESTION: 'question',
  GROUP: 'group',
  PROFILE: 'profile',
  OPINION: 'opinion',
  PRODUCT: 'product',
  ALL: 'all',
  ARTICLE: 'article',
};

export const SEARCH_TYPE_LIST = [
  SEARCH_TYPE.ALL,
  SEARCH_TYPE.PRODUCT,
  SEARCH_TYPE.ARTICLE,
  SEARCH_TYPE.OPINION,
  SEARCH_TYPE.QUESTION,
  SEARCH_TYPE.GROUP,
  SEARCH_TYPE.PROFILE,
];

export const SEARCH_TYPE_MAP = {
  [SEARCH_TYPE.ALL]: 'All Results',
  [SEARCH_TYPE.QUESTION]: 'Discussions',
  [SEARCH_TYPE.PROFILE]: 'Profiles',
  [SEARCH_TYPE.PRODUCT]: 'Products',
  [SEARCH_TYPE.ARTICLE]: 'Articles',
  [SEARCH_TYPE.GROUP]: 'Groups',
  [SEARCH_TYPE.OPINION]: 'Opinions',
};

export const SEARCH_BAR_OPTIONS = Object.freeze({
  shouldSort: true,
  tokenize: true,
  threshold: 0.2,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    {
      name: 'name',
      weight: 0.7,
    },
    {
      name: 'keyword',
      weight: 0.3,
    },
  ],
});

export const SEARCH_PAGE_OPTIONS = Object.freeze({
  shouldSort: true,
  tokenize: true,
  threshold: 0.2,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: ['name', 'keyword'],
});
